export const CUE_BACKGROUND_COLORS = [
  'transparent',
  '#3b0764', // purple-950
  '#052e16', // green-900
  '#172554', // blue-900
  '#4c0519', // rose-950
  '#713f12', // yellow-900
  '#404040', // neutral-700
  '#9333ea', // purple-600
  '#16a34a', // green-600
  '#2563eb', // blue-600
  '#e11d48', // rose-600
  '#ca8a04', // yellow-600
]

export const CELL_HIGHLIGHT_COLORS = [
  '#991b1b', // red-800
  '#6b21a8', // purple-800
  '#166534', // green-800
  '#1e40af', // blue-800
  '#9f1239', // rose-800
  '#854d0e', // yellow-800
  '#9a3412', // orange-800
  '#115e59', // teal-800
  '#86198f', // fuchsia-800
  '#075985', // sky-800
  '#3f6212', // lime-800
  '#000000', // black
  '#fca5a5', // red-300
  '#d8b4fe', // purple-300
  '#86efac', // green-300
  '#93c5fd', // blue-300
  '#fda4af', // rose-300
  '#fde047', // yellow-300
  '#fdba74', // orange-300
  '#5eead4', // teal-300
  '#f0abfc', // fuchsia-300
  '#7dd3fc', // sky-300
  '#bef264', // lime-300
]

export const CELL_TEXT_COLORS = [
  'rgb(252, 165, 165)', // red-300 #fca5a5
  'rgb(216, 180, 254)', // purple-300 #d8b4fe
  'rgb(134, 239, 172)', // green-300 #86efac
  'rgb(147, 197, 253)', // blue-300 #93c5fd
  'rgb(253, 164, 175)', // rose-300 #fda4af
  'rgb(253, 224, 71)', // yellow-300 #fde047
  'rgb(253, 186, 116)', // orange-300 #fdba74
  'rgb(94, 234, 212)', // teal-300 #5eead4
  'rgb(240, 171, 252)', // fuchsia-300 #f0abfc
  'rgb(125, 211, 252)', // sky-300 #7dd3fc
  'rgb(190, 242, 100)', // lime-300 #bef264
  'rgb(0, 0, 0)', // black #000
  'rgb(185, 28, 28)', // red-700 #b91c1c
  'rgb(126, 34, 206)', // purple-700 #7e22ce
  'rgb(21, 128, 61)', // green-700 #15803d
  'rgb(29, 78, 216)', // blue-700 #1d4ed8
  'rgb(190, 18, 60)', // rose-700 #be123c
  'rgb(161, 98, 7)', // yellow-700 #a16207
  'rgb(194, 65, 12)', // orange-700 #c2410c
  'rgb(15, 118, 110)', // teal-700 #0f766e
  'rgb(162, 28, 175)', // fuchsia-700 #a21caf
  'rgb(3, 105, 161)', // sky-700 #0369a1
  'rgb(77, 124, 15)', // lime-700 #4d7c0f
]

export const CELL_SELECT_COLORS = [
  '#991b1b', // bg-red-800
  '#166534', // bg-green-800
  '#6b21a8', // bg-purple-800
  '#854d0e', // bg-yellow-800
  '#1e40af', // bg-blue-800
  '#9f1239', // bg-rose-800
  '#115e59', // bg-teal-800
  '#9a3412', // bg-orange-800
  '#4338ca', // bg-indigo-700
  '#0e7490', // bg-cyan-700
  '#b45309', // bg-amber-700
  '#a21caf', // bg-fuchsia-700
  '#0369a1', // bg-sky-700
  '#047857', // bg-emerald-700
  '#be185d', // bg-pink-700
  '#4d7c0f', // bg-lime-700
]
